
import Vue from "vue";
import CareQuestion from '../../UI-Components/CareQuestion.vue'

export default Vue.extend({
  name: "SectionSeverityFrom2025",
  data() {
    return {
      totalNotSumMaleErrors: [] as string[],
      totalNotSumFemaleErrors: [] as string[],
      isTotalNotSumErrors: [] as string[],
    };
  },
  components: {
    'care-question': CareQuestion,
  },
  props: {
    isEditable: {
      type: Boolean,
      required: true,
    },
    tempData: {
      type: Object,
      required: true,
    },
    rules: {
      type: Object,
    },
    incrementedKey: {
      type: Number,
      required: true,
    },
    hasCancelled: {
      type: Number,
      required: true,
    },
  },
  watch: {
    isEditable(res) {
      if (!res) {
        this.isTotalNotSumErrors = [];
      }
    },
  },
  computed: {
    resultGrey() {
      if (
        this.tempData.patientsHemophiliaTypeA_Severity_HasNoData_Male &&
        this.tempData.patientsHemophiliaTypeA_Severity_HasNoData_Male_18AndUnder &&
        this.tempData.patientsHemophiliaTypeA_Severity_HasNoData_Male_Over18 &&
        this.tempData.patientsHemophiliaTypeA_Severity_HasNoData_Female &&
        this.tempData.patientsHemophiliaTypeA_Severity_HasNoData_Female_18AndUnder &&
        this.tempData.patientsHemophiliaTypeA_Severity_HasNoData_Female_Over18 &&
        this.tempData.patientsHemophiliaTypeB_Severity_HasNoData_Male &&
        this.tempData.patientsHemophiliaTypeB_Severity_HasNoData_Male_18AndUnder &&
        this.tempData.patientsHemophiliaTypeB_Severity_HasNoData_Male_Over18 &&
        this.tempData.patientsHemophiliaTypeB_Severity_HasNoData_Female &&
        this.tempData.patientsHemophiliaTypeB_Severity_HasNoData_Female_18AndUnder &&
        this.tempData.patientsHemophiliaTypeB_Severity_HasNoData_Female_Over18
      ) {
        this.tempData.severityHemophiliaIsInformationAccurate = null;
        return true;
      }
      return false;
    },
    sumOfHAM(): number {
      return (
        (this.tempData.patientsHemophiliaTypeA_Severity_Mild_Male || 0) +
        (this.tempData.patientsHemophiliaTypeA_Severity_Moderate_Male || 0) +
        (this.tempData.patientsHemophiliaTypeA_Severity_Severe_Male || 0) +
        (this.tempData.patientsHemophiliaTypeA_Severity_Unknown_Male || 0)
      );
    },
    // sumOfHAM18U(): number {
    //   return (
    //     (this.tempData.patientsHemophiliaTypeA_Severity_Mild_Male_18AndUnder || 0) +
    //     (this.tempData.patientsHemophiliaTypeA_Severity_Moderate_Male_18AndUnder || 0) +
    //     (this.tempData.patientsHemophiliaTypeA_Severity_Severe_Male_18AndUnder || 0) +
    //     (this.tempData.patientsHemophiliaTypeA_Severity_Unknown_Male_18AndUnder || 0)
    //   );
    // },
    // sumOfHAMO18(): number {
    //   return (
    //     (this.tempData.patientsHemophiliaTypeA_Severity_Mild_Male_Over18 || 0) +
    //     (this.tempData.patientsHemophiliaTypeA_Severity_Moderate_Male_Over18 || 0) +
    //     (this.tempData.patientsHemophiliaTypeA_Severity_Severe_Male_Over18 || 0) +
    //     (this.tempData.patientsHemophiliaTypeA_Severity_Unknown_Male_Over18 || 0)
    //   );
    // },
    sumOfHAF(): number {
      return (
        //(this.tempData.patientsHemophiliaTypeA_Severity_Carrier_Female || 0) + // Carrier is no longer took into account
        (this.tempData.patientsHemophiliaTypeA_Severity_Mild_Female || 0) +
        (this.tempData.patientsHemophiliaTypeA_Severity_Moderate_Female || 0) +
        (this.tempData.patientsHemophiliaTypeA_Severity_Severe_Female || 0) +
        (this.tempData.patientsHemophiliaTypeA_Severity_Unknown_Female || 0)
      );
    },
    // sumOfHAF18U(): number {
    //   return (
    //     //(this.tempData.patientsHemophiliaTypeA_Severity_Carrier_Female_18AndUnder || 0) + // Carrier is no longer took into account
    //     (this.tempData.patientsHemophiliaTypeA_Severity_Mild_Female_18AndUnder || 0) +
    //     (this.tempData.patientsHemophiliaTypeA_Severity_Moderate_Female_18AndUnder || 0) +
    //     (this.tempData.patientsHemophiliaTypeA_Severity_Severe_Female_18AndUnder || 0) +
    //     (this.tempData.patientsHemophiliaTypeA_Severity_Unknown_Female_18AndUnder || 0)
    //   );
    // },
    // sumOfHAFO18(): number {
    //   return (
    //     //(this.tempData.patientsHemophiliaTypeA_Severity_Carrier_Female_Over18 || 0) + // Carrier is no longer took into account
    //     (this.tempData.patientsHemophiliaTypeA_Severity_Mild_Female_Over18 || 0) +
    //     (this.tempData.patientsHemophiliaTypeA_Severity_Moderate_Female_Over18 || 0) +
    //     (this.tempData.patientsHemophiliaTypeA_Severity_Severe_Female_Over18 || 0) +
    //     (this.tempData.patientsHemophiliaTypeA_Severity_Unknown_Female_Over18 || 0)
    //   );
    // },
    sumOfHBM(): number {
      return (
        (this.tempData.patientsHemophiliaTypeB_Severity_Mild_Male || 0) +
        (this.tempData.patientsHemophiliaTypeB_Severity_Moderate_Male || 0) +
        (this.tempData.patientsHemophiliaTypeB_Severity_Severe_Male || 0) +
        (this.tempData.patientsHemophiliaTypeB_Severity_Unknown_Male || 0)
      );
    },
    // sumOfHBM18U(): number {
    //   return (
    //     (this.tempData.patientsHemophiliaTypeB_Severity_Mild_Male_18AndUnder || 0) +
    //     (this.tempData.patientsHemophiliaTypeB_Severity_Moderate_Male_18AndUnder || 0) +
    //     (this.tempData.patientsHemophiliaTypeB_Severity_Severe_Male_18AndUnder || 0) +
    //     (this.tempData.patientsHemophiliaTypeB_Severity_Unknown_Male_18AndUnder || 0)
    //   );
    // },
    // sumOfHBMO18(): number {
    //   return (
    //     (this.tempData.patientsHemophiliaTypeB_Severity_Mild_Male_Over18 || 0) +
    //     (this.tempData.patientsHemophiliaTypeB_Severity_Moderate_Male_Over18 || 0) +
    //     (this.tempData.patientsHemophiliaTypeB_Severity_Severe_Male_Over18 || 0) +
    //     (this.tempData.patientsHemophiliaTypeB_Severity_Unknown_Male_Over18 || 0)
    //   );
    // },
    sumOfHBF(): number {
      return (
        //(this.tempData.patientsHemophiliaTypeB_Severity_Carrier_Female || 0) + // Carrier is no longer took into account
        (this.tempData.patientsHemophiliaTypeB_Severity_Mild_Female || 0) +
        (this.tempData.patientsHemophiliaTypeB_Severity_Moderate_Female || 0) +
        (this.tempData.patientsHemophiliaTypeB_Severity_Severe_Female || 0) +
        (this.tempData.patientsHemophiliaTypeB_Severity_Unknown_Female || 0)
      );
    },
    // sumOfHBF18U(): number {
    //   return (
    //     //(this.tempData.patientsHemophiliaTypeB_Severity_Carrier_Female_18AndUnder || 0) + // Carrier is no longer took into account
    //     (this.tempData.patientsHemophiliaTypeB_Severity_Mild_Female_18AndUnder || 0) +
    //     (this.tempData.patientsHemophiliaTypeB_Severity_Moderate_Female_18AndUnder || 0) +
    //     (this.tempData.patientsHemophiliaTypeB_Severity_Severe_Female_18AndUnder || 0) +
    //     (this.tempData.patientsHemophiliaTypeB_Severity_Unknown_Female_18AndUnder || 0)
    //   );
    // },
    // sumOfHBFO18(): number {
    //   return (
    //     //(this.tempData.patientsHemophiliaTypeB_Severity_Carrier_Female_Over18 || 0) + // Carrier is no longer took into account
    //     (this.tempData.patientsHemophiliaTypeB_Severity_Mild_Female_Over18 || 0) +
    //     (this.tempData.patientsHemophiliaTypeB_Severity_Moderate_Female_Over18 || 0) +
    //     (this.tempData.patientsHemophiliaTypeB_Severity_Severe_Female_Over18 || 0) +
    //     (this.tempData.patientsHemophiliaTypeB_Severity_Unknown_Female_Over18 || 0)
    //   );
    // },
    sumOfSevereVWDTotal(): number {
      return (
        (this.tempData.patientsVWD_Severe_Male || 0) +
        (this.tempData.patientsVWD_Severe_Female || 0)
      );
    },
    sumOfSevereVWDTherapyTotal(): number {
      return (
        (this.tempData.patientsVWD_Severe_ReceivingReplacementTherapy_Male ||
          0) +
        (this.tempData.patientsVWD_Severe_ReceivingReplacementTherapy_Female ||
          0)
      );
    },
  },
  methods: {
    removeFromMaleErrors(column: string) {
      let index = this.totalNotSumMaleErrors.indexOf(column);
      if (index > -1) {
        this.totalNotSumMaleErrors.splice(index, 1);
      }
    },
    removeFromFemaleErrors(column: string) {
      let index = this.totalNotSumFemaleErrors.indexOf(column);
      if (index > -1) {
        this.totalNotSumFemaleErrors.splice(index, 1);
      }
    },
    ruleTotalSum(column: string) {
      if (
        column == "HAM" &&
        !this.tempData.patientsHemophiliaTypeA_Severity_HasNoData_Male &&
        this.tempData.patientsHemophiliaTypeA_Gender_Male != null
      ) {
        if (
          this.tempData.patientsHemophiliaTypeA_Gender_Male - this.sumOfHAM !=
          0
        ) {
          if (!this.totalNotSumMaleErrors.includes(column)) {
            this.totalNotSumMaleErrors.push(column);
          }
          return [false];
        } else {
          this.removeFromMaleErrors(column);
          return [true];
        }
      }
      /*if (
        column == "HAM18U" &&
        !this.tempData.patientsHemophiliaTypeA_Severity_HasNoData_Male_18AndUnder
      ) {
        if (
          (this.sumOfHAM18U + this.sumOfHAMO18) - this.sumOfHAM !=
          0
        ) {
          if (!this.totalNotSumMaleErrors.includes(column)) {
            this.totalNotSumMaleErrors.push(column);
          }
          return [false];
        } else {
          this.removeFromMaleErrors(column);
          return [true];
        }
      }
      if (
        column == "HAMO18" &&
        !this.tempData.patientsHemophiliaTypeA_Severity_HasNoData_Male_Over18
      ) {
        if (
          (this.sumOfHAM18U + this.sumOfHAMO18) - this.sumOfHAM !=
          0
        ) {
          if (!this.totalNotSumMaleErrors.includes(column)) {
            this.totalNotSumMaleErrors.push(column);
          }
          return [false];
        } else {
          this.removeFromMaleErrors(column);
          return [true];
        }
      }*/
      if (
        column == "HAF" &&
        !this.tempData.patientsHemophiliaTypeA_Severity_HasNoData_Female &&
        this.tempData.patientsHemophiliaTypeA_Gender_Female != null
      ) {
        if (
          this.tempData.patientsHemophiliaTypeA_Gender_Female - this.sumOfHAF !=
          0
        ) {
          if (!this.totalNotSumFemaleErrors.includes(column)) {
            this.totalNotSumFemaleErrors.push(column);
          }
          return [false];
        } else {
          this.removeFromFemaleErrors(column);
          return [true];
        }
      }
      /*if (
        column == "HAF18U" &&
        !this.tempData.patientsHemophiliaTypeA_Severity_HasNoData_Female_18AndUnder
      ) {
        if (
          (this.sumOfHAF18U + this.sumOfHAFO18) - this.sumOfHAF !=
          0
        ) {
          if (!this.totalNotSumFemaleErrors.includes(column)) {
            this.totalNotSumFemaleErrors.push(column);
          }
          return [false];
        } else {
          this.removeFromFemaleErrors(column);
          return [true];
        }
      }
      if (
        column == "HAFO18" &&
        !this.tempData.patientsHemophiliaTypeA_Severity_HasNoData_Female_Over18
      ) {
        if (
          (this.sumOfHAF18U + this.sumOfHAFO18) - this.sumOfHAF !=
          0
        ) {
          if (!this.totalNotSumFemaleErrors.includes(column)) {
            this.totalNotSumFemaleErrors.push(column);
          }
          return [false];
        } else {
          this.removeFromFemaleErrors(column);
          return [true];
        }
      }*/
      if (
        column == "HBM" &&
        !this.tempData.patientsHemophiliaTypeB_Severity_HasNoData_Male &&
        this.tempData.patientsHemophiliaTypeB_Gender_Male != null
      ) {
        if (
          this.tempData.patientsHemophiliaTypeB_Gender_Male - this.sumOfHBM !=
          0
        ) {
          if (!this.totalNotSumMaleErrors.includes(column)) {
            this.totalNotSumMaleErrors.push(column);
          }
          return [false];
        } else {
          this.removeFromMaleErrors(column);
          return [true];
        }
      }
      /*if (
        column == "HBM18U" &&
        !this.tempData.patientsHemophiliaTypeB_Severity_HasNoData_Male_18AndUnder
      ) {
        if (
          (this.sumOfHBM18U + this.sumOfHBMO18) - this.sumOfHBM !=
          0
        ) {
          if (!this.totalNotSumMaleErrors.includes(column)) {
            this.totalNotSumMaleErrors.push(column);
          }
          return [false];
        } else {
          this.removeFromMaleErrors(column);
          return [true];
        }
      }
      if (
        column == "HBMO18" &&
        !this.tempData.patientsHemophiliaTypeB_Severity_HasNoData_Male_Over18
      ) {
        if (
          (this.sumOfHBM18U + this.sumOfHBMO18) - this.sumOfHBM !=
          0
        ) {
          if (!this.totalNotSumMaleErrors.includes(column)) {
            this.totalNotSumMaleErrors.push(column);
          }
          return [false];
        } else {
          this.removeFromMaleErrors(column);
          return [true];
        }
      }*/
      if (
        column == "HBF" &&
        !this.tempData.patientsHemophiliaTypeB_Severity_HasNoData_Female &&
        this.tempData.patientsHemophiliaTypeB_Gender_Female != null
      ) {
        if (
          this.tempData.patientsHemophiliaTypeB_Gender_Female - this.sumOfHBF !=
          0
        ) {
          if (!this.totalNotSumFemaleErrors.includes(column)) {
            this.totalNotSumFemaleErrors.push(column);
          }
          return [false];
        } else {
          this.removeFromFemaleErrors(column);
          return [true];
        }
      }
      /*if (
        column == "HBF18U" &&
        !this.tempData.patientsHemophiliaTypeB_Severity_HasNoData_Female_18AndUnder
      ) {
        if (
          (this.sumOfHBF18U + this.sumOfHBFO18) - this.sumOfHBF !=
          0
        ) {
          if (!this.totalNotSumFemaleErrors.includes(column)) {
            this.totalNotSumFemaleErrors.push(column);
          }
          return [false];
        } else {
          this.removeFromFemaleErrors(column);
          return [true];
        }
      }
      if (
        column == "HBFO18" &&
        !this.tempData.patientsHemophiliaTypeB_Severity_HasNoData_Female_Over18
      ) {
        if (
          (this.sumOfHBF18U + this.sumOfHBFO18) - this.sumOfHBF !=
          0
        ) {
          if (!this.totalNotSumFemaleErrors.includes(column)) {
            this.totalNotSumFemaleErrors.push(column);
          }
          return [false];
        } else {
          this.removeFromFemaleErrors(column);
          return [true];
        }
      }*/
    },
    ruleTotalIsSum(
      total: number,
      men: number,
      menNoData: boolean,
      women: number,
      womenNoData: boolean,
      unkwn: number,
      unkwnNoData: boolean,
      question: string,
      totalNodata: boolean
    ) {
      if (!totalNodata) {
        if (menNoData == true && womenNoData == true && unkwnNoData == true) {
          this.removeFromErrors(question);
          if (total != null && total >= 0 && typeof total == "number")
            return [];
          else return [this.$i18n.t("rules.required")];
        } else if (total != null && total >= 0 && typeof total == "number") {
          if (total - men - women - unkwn != 0) {
            if (!this.isTotalNotSumErrors.includes(question)) {
              this.isTotalNotSumErrors.push(question);
            }
            return [false];
          } else {
            this.removeFromErrors(question);
            return [];
          }
        } else {
          this.removeFromErrors(question);
          return [this.$i18n.t("rules.required")];
        }
      } else {
        this.removeFromErrors(question);
        return [];
      }
    },
    removeFromErrors(question: string) {
      let index = this.isTotalNotSumErrors.indexOf(question);
      if (index > -1) {
        this.isTotalNotSumErrors.splice(index, 1);
      }
    },
    clearHemophiliaTypeASeverityMaleRow() {
      if (this.tempData.patientsHemophiliaTypeA_Severity_HasNoData_Male) {
        this.tempData.patientsHemophiliaTypeA_Severity_Mild_Male = null;
        this.tempData.patientsHemophiliaTypeA_Severity_Moderate_Male = null;
        this.tempData.patientsHemophiliaTypeA_Severity_Severe_Male = null;
        this.tempData.patientsHemophiliaTypeA_Severity_Unknown_Male = null;
        this.removeFromMaleErrors("HAM");
      }
    },
    clearHemophiliaTypeASeverityMale18AndUnderRow() {
      if (this.tempData.patientsHemophiliaTypeA_Severity_HasNoData_Male_18AndUnder) {
        this.tempData.patientsHemophiliaTypeA_Severity_Mild_Male_18AndUnder = null;
        this.tempData.patientsHemophiliaTypeA_Severity_Moderate_Male_18AndUnder = null;
        this.tempData.patientsHemophiliaTypeA_Severity_Severe_Male_18AndUnder = null;
        this.tempData.patientsHemophiliaTypeA_Severity_Unknown_Male_18AndUnder = null;
        this.removeFromMaleErrors("HAM18U");
      }
    },
    clearHemophiliaTypeASeverityMaleOver18Row() {
      if (this.tempData.patientsHemophiliaTypeA_Severity_HasNoData_Male_Over18) {
        this.tempData.patientsHemophiliaTypeA_Severity_Mild_Male_Over18 = null;
        this.tempData.patientsHemophiliaTypeA_Severity_Moderate_Male_Over18 = null;
        this.tempData.patientsHemophiliaTypeA_Severity_Severe_Male_Over18 = null;
        this.tempData.patientsHemophiliaTypeA_Severity_Unknown_Male_Over18 = null;
        this.removeFromMaleErrors("HAMO18");
      }
    },
    clearHemophiliaTypeASeverityFemaleRow() {
      if (this.tempData.patientsHemophiliaTypeA_Severity_HasNoData_Female) {
        this.tempData.patientsHemophiliaTypeA_Severity_Carrier_Female = null;
        this.tempData.patientsHemophiliaTypeA_Severity_Mild_Female = null;
        this.tempData.patientsHemophiliaTypeA_Severity_Moderate_Female = null;
        this.tempData.patientsHemophiliaTypeA_Severity_Severe_Female = null;
        this.tempData.patientsHemophiliaTypeA_Severity_Unknown_Female = null;
        this.removeFromFemaleErrors("HAF");
      }
    },
    clearHemophiliaTypeASeverityFemale18AndUnderRow() {
      if (this.tempData.patientsHemophiliaTypeA_Severity_HasNoData_Female_18AndUnder) {
        this.tempData.patientsHemophiliaTypeA_Severity_Carrier_Female_18AndUnder = null;
        this.tempData.patientsHemophiliaTypeA_Severity_Mild_Female_18AndUnder = null;
        this.tempData.patientsHemophiliaTypeA_Severity_Moderate_Female_18AndUnder = null;
        this.tempData.patientsHemophiliaTypeA_Severity_Severe_Female_18AndUnder = null;
        this.tempData.patientsHemophiliaTypeA_Severity_Unknown_Female_18AndUnder = null;
        this.removeFromFemaleErrors("HAF18U");
      }
    },
    clearHemophiliaTypeASeverityFemaleOver18Row() {
      if (this.tempData.patientsHemophiliaTypeA_Severity_HasNoData_Female_Over18) {
        this.tempData.patientsHemophiliaTypeA_Severity_Carrier_Female_Over18 = null;
        this.tempData.patientsHemophiliaTypeA_Severity_Mild_Female_Over18 = null;
        this.tempData.patientsHemophiliaTypeA_Severity_Moderate_Female_Over18 = null;
        this.tempData.patientsHemophiliaTypeA_Severity_Severe_Female_Over18 = null;
        this.tempData.patientsHemophiliaTypeA_Severity_Unknown_Female_Over18 = null;
        this.removeFromFemaleErrors("HAFO18");
      }
    },
    clearHemophiliaTypeBSeverityMaleRow() {
      if (this.tempData.patientsHemophiliaTypeB_Severity_HasNoData_Male) {
        this.tempData.patientsHemophiliaTypeB_Severity_Mild_Male = null;
        this.tempData.patientsHemophiliaTypeB_Severity_Moderate_Male = null;
        this.tempData.patientsHemophiliaTypeB_Severity_Severe_Male = null;
        this.tempData.patientsHemophiliaTypeB_Severity_Unknown_Male = null;
        this.removeFromMaleErrors("HBM");
      }
    },
    clearHemophiliaTypeBSeverityMale18AndUnderRow() {
      if (this.tempData.patientsHemophiliaTypeB_Severity_HasNoData_Male_18AndUnder) {
        this.tempData.patientsHemophiliaTypeB_Severity_Mild_Male_18AndUnder = null;
        this.tempData.patientsHemophiliaTypeB_Severity_Moderate_Male_18AndUnder = null;
        this.tempData.patientsHemophiliaTypeB_Severity_Severe_Male_18AndUnder = null;
        this.tempData.patientsHemophiliaTypeB_Severity_Unknown_Male_18AndUnder = null;
        this.removeFromMaleErrors("HBM18U");
      }
    },
    clearHemophiliaTypeBSeverityMaleOver18Row() {
      if (this.tempData.patientsHemophiliaTypeB_Severity_HasNoData_Male_Over18) {
        this.tempData.patientsHemophiliaTypeB_Severity_Mild_Male_Over18 = null;
        this.tempData.patientsHemophiliaTypeB_Severity_Moderate_Male_Over18 = null;
        this.tempData.patientsHemophiliaTypeB_Severity_Severe_Male_Over18 = null;
        this.tempData.patientsHemophiliaTypeB_Severity_Unknown_Male_Over18 = null;
        this.removeFromMaleErrors("HBMO18");
      }
    },
    clearHemophiliaTypeBSeverityFemaleRow() {
      if (this.tempData.patientsHemophiliaTypeB_Severity_HasNoData_Female) {
        this.tempData.patientsHemophiliaTypeB_Severity_Carrier_Female = null;
        this.tempData.patientsHemophiliaTypeB_Severity_Mild_Female = null;
        this.tempData.patientsHemophiliaTypeB_Severity_Moderate_Female = null;
        this.tempData.patientsHemophiliaTypeB_Severity_Severe_Female = null;
        this.tempData.patientsHemophiliaTypeB_Severity_Unknown_Female = null;
        this.removeFromFemaleErrors("HBF");
      }
    },
    clearHemophiliaTypeBSeverityFemale18AndUnderRow() {
      if (this.tempData.patientsHemophiliaTypeB_Severity_HasNoData_Female_18AndUnder) {
        this.tempData.patientsHemophiliaTypeB_Severity_Carrier_Female_18AndUnder = null;
        this.tempData.patientsHemophiliaTypeB_Severity_Mild_Female_18AndUnder = null;
        this.tempData.patientsHemophiliaTypeB_Severity_Moderate_Female_18AndUnder = null;
        this.tempData.patientsHemophiliaTypeB_Severity_Severe_Female_18AndUnder = null;
        this.tempData.patientsHemophiliaTypeB_Severity_Unknown_Female_18AndUnder = null;
        this.removeFromFemaleErrors("HBF18U");
      }
    },
    clearHemophiliaTypeBSeverityFemaleOver18Row() {
      if (this.tempData.patientsHemophiliaTypeB_Severity_HasNoData_Female_Over18) {
        this.tempData.patientsHemophiliaTypeB_Severity_Carrier_Female_Over18 = null;
        this.tempData.patientsHemophiliaTypeB_Severity_Mild_Female_Over18 = null;
        this.tempData.patientsHemophiliaTypeB_Severity_Moderate_Female_Over18 = null;
        this.tempData.patientsHemophiliaTypeB_Severity_Severe_Female_Over18 = null;
        this.tempData.patientsHemophiliaTypeB_Severity_Unknown_Female_Over18 = null;
        this.removeFromFemaleErrors("HBFO18");
      }
    },
    clearVWDSevereTotalRow(numba: number) {
      if (numba == 1 && this.tempData.patientsVWD_Severe_Total_IsNotKnown) {
        this.tempData.patientsVWD_Severe_Total = null;
      }
      if (
        numba == 2 &&
        this.tempData
          .patientsVWD_Severe_ReceivingReplacementTherapy_Total_IsNotKnown
      ) {
        this.tempData.patientsVWD_Severe_ReceivingReplacementTherapy_Total = null;
      }
    },
    clearVWDSevereMaleRow(numba: number) {
      if (numba == 1 && this.tempData.patientsVWD_Severe_IsNotKnown_Male) {
        this.tempData.patientsVWD_Severe_Male = null;
      }
      if (
        numba == 2 &&
        this.tempData
          .patientsVWD_Severe_ReceivingReplacementTherapy_IsNotKnown_Male
      ) {
        this.tempData.patientsVWD_Severe_ReceivingReplacementTherapy_Male = null;
      }
    },
    clearVWDSevereFemaleRow(numba: number) {
      if (numba == 1 && this.tempData.patientsVWD_Severe_IsNotKnown_Female) {
        this.tempData.patientsVWD_Severe_Female = null;
      }
      if (
        numba == 2 &&
        this.tempData
          .patientsVWD_Severe_ReceivingReplacementTherapy_IsNotKnown_Female
      ) {
        this.tempData.patientsVWD_Severe_ReceivingReplacementTherapy_Female = null;
      }
    },
    clearVWDSevereUnknownRow(numba: number) {
      if (numba == 1 && this.tempData.patientsVWD_Severe_IsNotKnown_Unknown) {
        this.tempData.patientsVWD_Severe_Unknown = null;
      }
      if (
        numba == 2 &&
        this.tempData
          .patientsVWD_Severe_ReceivingReplacementTherapy_IsNotKnown_Unknown
      ) {
        this.tempData.patientsVWD_Severe_ReceivingReplacementTherapy_Unknown = null;
      }
    },
  },
});
